import { NAME } from './constants';

export const SET_SESSION_ITEM = `${NAME}/SET_SESSION_ITEM`;
export const SET_COMPONENT_STATE = `${NAME}/SET_COMPONENT_STATE`;
